import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Section, { SectionHeader, SectionTitle, SectionBody } from 'components/common/Section';
import Link from 'components/common/Link';

import {
  requestDownloadDataPortabilityExample,
  requestDownloadDataPortabilityTemplate,
} from 'redux/modules/dataPortability';

import DataPortabilityForm from './DataPortabilityForm';

const styles = theme => ({
  sectionHeader: {
    paddingTop: 30,
    paddingBottom: 30,
  },
  grid: {
    minHeight: 'calc(100vh - 277px)',
    height: 100,
  },
  typographyList: {
    padding: 0,
    margin: '15px 0 30px',
  },
  menuItem: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingRight: 40,
    textAlign: 'left',
    '&:focus $iconDownload, &:hover $iconDownload': {
      opacity: 1,
    },
  },
  iconDownload: {
    width: 14,
    height: 17,
    position: 'absolute',
    right: 20,
    top: '50%',
    opacity: 0,
    transform: 'translateY(-50%)',
    color: theme.palette.primary.A400,
    transition: theme.transitions.create(['opacity'], {
      duration: theme.transitions.duration.shortest,
    }),
  },
  iconImportFile: {
    verticalAlign: 'middle',
    width: 19,
    height: 22,
    marginRight: 10,
  },
  link: {
    marginTop: 10,
  },
});

class DataPortability extends Component {
  constructor(props) {
    super(props);

    this.onDownloadTemplateButtonClick = this.onDownloadTemplateButtonClick.bind(this);
    this.onDownloadExampleButtonClick = this.onDownloadExampleButtonClick.bind(this);
  }

  onDownloadTemplateButtonClick() {
    const { Route } = this.props;
    requestDownloadDataPortabilityTemplate(Route);
  }

  onDownloadExampleButtonClick() {
    const { Route } = this.props;
    requestDownloadDataPortabilityExample(Route);
  }

  render() {
    const { Title, Route, classes } = this.props;
    return (
      <Section>
        <SectionHeader className={classes.sectionHeader}>
          <div>
            <SectionTitle gutterBottom>
              Import your {Title} information
            </SectionTitle>
            <Typography variant="caption">
              Contact out customer service team for help
              exporting {Title} from your existing system to ours
            </Typography>
          </div>
        </SectionHeader>
        <SectionBody className={classes.sectionBody}>
          <Grid
            className={classes.grid}
            container
            alignItems="center"
            justify="center"
            spacing={40}
          >
            <Grid item>
              <DataPortabilityForm
                ID={Route}
              />
            </Grid>
            <Grid item xs={5}>
              <Typography variant="subheading">
                Uploaded file should have
              </Typography>
              <Typography
                className={classes.typographyList}
                component="ul"
              >
                <Typography
                  color="secondary"
                  component="li"
                  gutterBottom
                >
                  A spreadsheet format (i.e. Excel)
                </Typography>
                <Typography
                  color="secondary"
                  component="li"
                  gutterBottom
                >
                  One row per data item
                </Typography>
                <Typography
                  color="secondary"
                  component="li"
                  gutterBottom
                >
                  A header row (Name, phone, etc.)
                </Typography>
              </Typography>
              <Typography
                className={classes.typographyList}
                component="ul"
              >
                <Typography
                  color="secondary"
                  component="li"
                  gutterBottom
                >
                  <Link
                    className={classes.link}
                    color="primary"
                    bold
                    size="md"
                    onClick={this.onDownloadExampleButtonClick}
                  >
                    Download an example file
                  </Link>
                </Typography>
                <Typography
                  color="secondary"
                  component="li"
                  gutterBottom
                >
                  <Link
                    className={classes.link}
                    color="primary"
                    bold
                    size="md"
                    onClick={this.onDownloadTemplateButtonClick}
                  >
                    Download a template file
                  </Link>
                </Typography>
              </Typography>
            </Grid>
          </Grid>
        </SectionBody>
      </Section>
    );
  }
}

DataPortability.propTypes = {
  Title: PropTypes.string,
  Route: PropTypes.string,
  classes: PropTypes.shape({
    sectionHeader: PropTypes.string.isRequired,
    grid: PropTypes.string.isRequired,
    typographyList: PropTypes.string.isRequired,
    menuItem: PropTypes.string.isRequired,
    iconImportFile: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
};

DataPortability.defaultProps = {
  Title: null,
  Route: null,
};

export default withStyles(styles)(DataPortability);



// WEBPACK FOOTER //
// ./src/components/settings/DataPortability/DataPortability.js